module.exports = __webpack_public_path__ + "img/complete-logo-footer.402abe4b.svg";